<template>
    <div class="news-menu">
        <header>
            <h1>news</h1>

            <!-- <div>
                <span class="txt-line" @click="filterWord=''">all</span>
                <span class="txt-line" v-for="key in keywords" :key="key" @click="filterWord=key">{{ key }}</span>
            </div> -->
        </header>

        <div class="container">
            
            <div class="card empty" v-show="posts.length==0" v-for="x in 3" :key="x">
                <div class="img"></div>
                <div class="content">
                    <div class="date"></div>
                    <div class="title"></div>
                    <button class="txt"></button>
                </div>
            </div>

            <router-link class="card" :to="`/news/${x.slug}`" tag="div" v-for="(x, index) in posts" :key="index">
                <div class="img">
                    <img loading="lazy" :src="x.postImg" alt="news image">
                </div>
                <div class="content">
                    <div class="date">{{ x.date}}</div>
                    <div class="title">{{ x.slug.replaceAll("-", " ") }}</div>
                    <router-link :to="`/news/${x.slug}`" tag="button" class="txt">explore</router-link>
                </div>
            </router-link>
        </div>

        <div class="navigation-bar">
            <!-- First Page Button -->
            <button name="first page" class="square" @click="navigationBtn(1)" v-if="pagination?.hasPrevious"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" /></svg></button>

            <!-- Page Buttons -->
            <button :name="`button page ${x}`" class="square" @click="navigationBtn(x)" v-for="x in paginationButtons" :key="x" :class="{ active: +$route.query.page == x }">{{ x }}</button>

            <!-- Last Page Button -->
            <button name="last page" class="square" @click="navigationBtn(pagination?.totalPages)" v-if="pagination?.hasNext"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" /></svg></button></div>

    </div>
</template>

<script>
    import api from "@/apis.js";
    export default {
        data() {
            return {
                posts: [],
                keywords: [],
                filterWord: "",
                pagination: null,
            }
        },
        computed: {
            paginationButtons() {
                const totalPages = this.pagination?.totalPages;
                const current = this.pagination?.page;
                let start, end;

                if (totalPages <= 3) {
                // Less than 3 pages, show all
                start = 1;
                end = totalPages;
                } else if (current === 1) {
                start = 1;
                end = 3;
                } else if (current === totalPages) {
                start = totalPages - 2;
                end = totalPages;
                } else {
                start = current - 1;
                end = current + 1;

                // Correct for edges
                if (start < 1) start = 1;
                if (end > totalPages) end = totalPages;
                }

                // Build array of page numbers
                const pages = [];
                for (let i = start; i <= end; i++) {
                pages.push(i);
                }
                return pages;
            }
        },
        watch: {
            filterWord() {
                console.log(1);
                
                this.posts.forEach(el => {
                    el.isVisible = false;

                    if(el.keywords.includes(this.filterWord)) {
                        el.isVisible = true;
                    }
                    else if (this.filterWord === "") {
                        el.isVisible = true;
                    }
                })
            }
        },
        methods: {
            getNews(page) {
                const p = page ? page:1;
                console.log(p);
                console.log('fffff', api);
                
                api.get(`/news?page=${p}`)
                .then(res => {
                    this.posts = res.data.data;
                    this.pagination = res.data.pagination;
                    
                })
                .catch(err => {
                    console.log(err)
                })
            },
            navigationBtn(n) {
                scrollTo(0,0);
                if (!n) {
                    let currentPage = this.$route.query.page;
                    if (Number(currentPage)) {this.getNews(currentPage);}
                    else {
                        console.log('this path isnt suppported');
                        this.$router.push({
                            path: this.$route.path,
                            query: {
                                ...this.$route.query,
                                page: 1
                            }
                        })
                        this.getNews();
                    }
                }
                else {
                    let currentPage = this.$route.query.page;
                    if (n != currentPage) {
                        this.$router.push({
                            path: this.$route.path,
                            query: {
                                ...this.$route.query,
                                page: n
                            }
                        })
                        this.getNews(n);
                    }
                }
            }
        },
        mounted() {// new to the news page - first page loads
            if (!this.$route.query.page) {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: 1
                    }
                })
                this.getNews();
            }
            else {this.navigationBtn();}
        }
    }
</script>